import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Orbit, RotateCcw } from "lucide-react";
import PublicShell, { WIDE } from "@/components/PublicShell";
import { api } from "@/lib/apiClient";
import { usePageMeta } from "@/lib/seo";
import { PLANET_PAGES } from "@/lib/planetFacts";
import RetroBanner from "@/components/RetroBanner";

export default function TransitsIndex() {
  const [d, setD] = useState(null);
  usePageMeta("Planets Today: Live Planetary Positions · Astra", "/transits",
    "Where are the planets today? Live positions of the Sun, Moon, Mercury, Venus, Mars, Jupiter, Saturn, Uranus and Neptune, with what each means.");
  useEffect(() => { api.get("/public/transits").then(({ data }) => setD(data)).catch(() => setD({ planets: [] })); }, []);
  const live = Object.fromEntries((d?.planets || []).map((p) => [p.slug, p]));
  return (
    <PublicShell testId="transits-index">
      <div className={`px-5 pt-6 pb-10 fade-up ${WIDE ? "lg:max-w-4xl lg:mx-auto lg:pt-12" : ""}`}>
        <p className="text-[11px] uppercase tracking-[0.3em] gold-text"><Orbit size={11} className="inline -mt-0.5 mr-1" />Daily planets</p>
        <h1 className="text-4xl sm:text-5xl font-light mt-2 mb-3">The planets today</h1>
        <p className="text-base text-[#A7B0C0] mb-6">Live positions calculated from the real sky, with a fresh note on what each planet means today. See the <Link to="/moon-calendar" className="gold-text" data-testid="transits-moon-calendar">Moon phase calendar</Link>.</p>
        <RetroBanner planets={["Mercury", "Venus", "Mars", "Jupiter", "Saturn", "Uranus", "Neptune"]} className="mb-4" />
        <div className="grid gap-3 sm:grid-cols-2">
          {Object.entries(PLANET_PAGES).map(([s, p]) => (
            <Link key={s} to={`/transits/${s}`} data-testid={`transits-card-${s}`} className="bg-[#0F1523]/90 border border-[#D4AF37]/25 hover:border-[#D4AF37]/60 rounded-2xl p-5 transition-colors">
              <p className="text-xl font-light"><span className="gold-text mr-2">{p.glyph}</span>{p.name}</p>
              <p className="text-sm text-[#E8DCC4] mt-1">{live[s] ? [live[s], ...(live[s].also || [])].map((b, i) => (
                <span key={b.planet} className="block">{live[s].also?.length ? `${b.planet} ` : ""}in {b.sign} at {b.degree}°{b.retrograde && <RotateCcw size={11} className="inline ml-1.5 -mt-0.5" />}</span>
              )) : "Today's position"}</p>
            </Link>
          ))}
        </div>
      </div>
    </PublicShell>
  );
}
